export enum TestConnectionState {
  Disabled = 'Disabled',
  Running = 'Running',
  Completed = 'Completed',
  Failed = 'Failed',
  NotStarted = 'NotStarted'
}
